import { mapActions } from 'vuex';

export default {
    methods: {
        ...mapActions({
            requestConfirmation: 'confirm/requestConfirmation',
        }),
    },
};
